import {
  Box,
  Heading,
  VStack,
  Text,
  Grid,
  GridItem,
  Flex,
  Input,
  HStack,
  Select,
} from "@chakra-ui/react";
import CrmDataService from "../services/data";
import { useEffect, useState } from "react";
import { MoonLoader } from "react-spinners";
import { DateTime } from "luxon";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

export const AdminDashboard = () => {
  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];

  const loggedInUser = localStorage.getItem("logged_in_user_id");
  const navigate = useNavigate();

  const capitalize = (str: any) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const owners = accessControls.includes("salesAdmin")
    ? [
        { name: "User2", id: "expert_mahi" },
        { name: "User3", id: "expert_divanshi" },
        { name: "User4", id: "expert_navyav" },
        { name: "Prakriti", id: "expert_prakriti" },
        { name: "Jigyasa", id: "expert_jigyasa" },
        { name: "Tania", id: "expert_tania" },
        // { name: "User1", id: "expert4_tamannarajpal" },
      ]
    : [{ name: capitalize(loggedInUser?.split("_")[1]), id: loggedInUser }];

  const metricLabels: any = {
    totalHot: "Hot Leads",
    totalWarm: "Warm Leads",
    totalCold: "Cold Leads",
    ehcLeads: "EHC Leads",
    assignedLeads: "Assigned Leads",
    totalSingle: "Single Sessions",
    totalSubs: "Subscriptions",
    totalLeads: "Total Leads",
    totalUniqueFollowups: "Total FollowedUp",
    markedLeads: "Marked Leads",
    totalBookings: "Total Bookings",
  };

  const [ownerData, setOwnerData] = useState([]);

  const [option, setOption] = useState("today"); // "today" or "custom"

  const [selectedDates, setSelectedDates] = useState([new Date(), new Date()]);

  const [loading, setLoading] = useState(false);

  const [type, setType] = useState("today");

  const firstDayOfMonth = DateTime.now().startOf("month").toISODate();
  const yesterday = DateTime.now().toISODate();

  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(yesterday);

  const getAdminData = async () => {
    let startDate, endDate;

    if (option === "today") {
      startDate = new Date();
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date();
      endDate.setHours(23, 59, 59, 999);
    } else {
      [startDate, endDate] = selectedDates;
    }

    // Convert to ISO strings for consistency
    const startISO = startDate.toISOString();
    const endISO = endDate.toISOString();

    setLoading(true);
    if (type === "today") {
      const results: any = await Promise.all(
        owners.map(async (owner) => {
          const res = await CrmDataService.getAdminData(owner.id);
          return {
            ...owner,
            data: res?.data?.data || {},
          };
        }),
      );
      setOwnerData(results);
    } else {
      const results: any = await Promise.all(
        owners.map(async (owner) => {
          const res = await CrmDataService.getAdminDataForDateRange(
            owner.id,
            startISO,
            endISO,
          );
          return {
            ...owner,
            data: res?.data?.data || {},
          };
        }),
      );
      setOwnerData(results);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAdminData();
  }, [type, startDate, endDate]);

  const handleSubmit = () => {
    if (option === "today") {
      const startDate = new Date();
      startDate.setHours(0, 0, 0, 0);
      const endDate = new Date();
      endDate.setHours(23, 59, 59, 999);
    } else {
    }
  };

  return (
    <Box bg="#f0f7f7" minH="100vh" pb={8} display="flex" flexDirection="column">
      {loading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          backgroundColor="rgba(255, 255, 255, 0.6)"
          zIndex={10}
        >
          <MoonLoader color="#327171" size={50} />
        </Box>
      )}

      <Flex
        bg="#406661"
        color="white"
        p={6}
        mb={6}
        // justify="center"
        alignItems="center"
      >
        <Flex flex="1" gap={6}>
          <Box display="flex" alignItems="center">
            <IoArrowBackCircleSharp
              size="26"
              cursor="pointer"
              onClick={() => navigate("/")}
            />
          </Box>
          <Heading size="md" fontWeight="semibold" textAlign="center">
            {accessControls.includes("salesAdmin")
              ? "Admin Dashboard"
              : `${capitalize(loggedInUser?.split("_")[1] || "")}'s Dashboard`}
          </Heading>
        </Flex>
        <HStack align="end" spacing={8} height={12}>
          {type === "date-range" && (
            <HStack spacing={2} align="center">
              <VStack align="start" spacing={0}>
                <Text fontSize="sm" fontWeight="semibold">
                  From
                </Text>
                <Input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </VStack>
              <VStack align="start" spacing={0}>
                <Text fontSize="sm" fontWeight="semibold">
                  To
                </Text>
                <Input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  max={DateTime.now().toISODate()}
                />
              </VStack>
            </HStack>
          )}

          <Select
            w="100"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="today">Today</option>
            <option value="date-range">Date Range</option>
          </Select>
        </HStack>
      </Flex>
      <VStack spacing={20} mx="auto">
        {ownerData.map((owner: any) => (
          <Box key={owner.id}>
            {accessControls.includes("salesAdmin") && (
              <Heading size="sm" mb={4} color="#406661">
                {owner.name}
              </Heading>
            )}

            <Grid
              templateColumns={
                type === "today"
                  ? {
                      base: "repeat(2, 1fr)",
                      md: "repeat(3, 1fr)",
                      lg: "repeat(10, 0.5fr)",
                    }
                  : {
                      base: "repeat(1, 1fr)",
                      md: "repeat(2, 1fr)",
                      lg: "repeat(6, 1fr)",
                    }
              }
              gap={6}
            >
              {Object.entries(owner.data).map(([key, value]) => (
                <GridItem key={key}>
                  <Box
                    bg="#f5a623"
                    color="white"
                    py={4}
                    px={4}
                    borderRadius="md"
                    textAlign="center"
                    boxShadow="md"
                    minW="120px"
                    minH="120px"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <Text fontSize="sm" mb={1} fontWeight="medium">
                      {metricLabels[key]}
                    </Text>
                    <Text fontSize="xl" fontWeight="bold">
                      {String(value)}
                    </Text>
                  </Box>
                </GridItem>
              ))}
            </Grid>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};
